/**
 * Pure utils for the Suppliers form.
 * @typedef {import('../../../models/Supplier').Supplier} Supplier
 */

import { SUPPLIERS_QUERY_KEY as SK, LIST_STALE_TIME_MS } from '../../common/utils/queryKeys';

export const SUPPLIERS_QUERY_KEY = SK;
export { LIST_STALE_TIME_MS };

export const emptyFormData = () => ({
  name: '',
  country: '',
  website: ''
});

/** @param {Supplier} supplier */
export const supplierToFormData = (supplier) => ({
  name: supplier.name ?? '',
  country: supplier.country ?? '',
  website: supplier.website ?? ''
});
